import { useI18n } from '@/i18n/I18nProvider';
import { legal, PRIVACY_LAST_UPDATED } from '@/i18n/legal';
import LegalPageShell from '@/components/site/LegalPageShell';
import LegalSections from '@/components/site/LegalSections';

export default function ImpressumPage() {
  const { locale } = useI18n();
  const copy = legal[locale].impressum;

  return (
    <LegalPageShell
      testId="impressum-page"
      titleTestId="impressum-page-title"
      backTestId="impressum-back-home"
      eyebrow={copy.eyebrow}
      title={copy.title}
      lead={copy.intro}
    >
      <LegalSections
        sections={copy.sections}
        locale={locale}
        sectionTestIdPrefix="impressum-section"
      />
      <p className="text-xs uppercase tracking-[0.18em] text-muted-foreground/70 pt-10">
        {PRIVACY_LAST_UPDATED[locale]}
      </p>
    </LegalPageShell>
  );
}
